export default "__VITE_ASSET__O0sZnpew__"